<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="вид услуг"
      :is-disabled="isDisabled"
      :initial-value="value"
      :get-item-by-id="getWorkService"
      :get-list="getItems"
      :can-create-catalog="canEditWorkService()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <work-service
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import CatalogSelect from "../CatalogSelect.vue";
    import WorkService from "./WorkService.vue";

export default {
  name: "WorkServiceSelect",
  components: { WorkService, CatalogSelect },
  mixins: [
    catalogs,
    permissions
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getWorkServices({});
      return (result && result.data && result.data.items) ? result.data.items : [];
    },
    async getWorkService(id) {
      const result = await this.getWorkServiceById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditWorkService() {
      return this.hasPermission([PERM.CATALOG_WORK_SERVICE_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkServices/WorkServiceSelect.vue